import type { Modifier } from '@dnd-kit/core'
import { getEventCoordinates } from '@dnd-kit/utilities'
import { PROJECT_DRAG_CARD_HEIGHT } from '../ProjectDragOverlay'

/** Abstand der Karte rechts vom Zeiger (gewünscht 30.09.2026). */
export const CARD_CURSOR_GAP = 8

/**
 * Stellt die Karte am Zeiger (`ProjectDragOverlay`) **rechts neben den Zeiger**, vertikal mittig
 * — statt sie dort zu lassen, wo die Zeile angefasst wurde (dann lag sie unter dem Zeiger).
 * Nur für das `DragOverlay`: Die Ablage rechnet weiter mit dem Weg des Zeigers.
 */
export const cardBesideCursor: Modifier = ({ activatorEvent, draggingNodeRect, transform }) => {
  const pointer = activatorEvent ? getEventCoordinates(activatorEvent) : null
  if (!pointer || !draggingNodeRect) return transform
  return {
    ...transform,
    x: transform.x + pointer.x - draggingNodeRect.left + CARD_CURSOR_GAP,
    y: transform.y + pointer.y - draggingNodeRect.top - PROJECT_DRAG_CARD_HEIGHT / 2,
  }
}
